/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React from 'react'

const button = css`
  background-color: #f7c02d;
  border: none;
  outline: none;
  width: 100px;
  height: 40px;
  border-radius: 3px;
  margin-top: 20px;
  &:hover {
    cursor: pointer;
    color: #fff;
    transition: all 0.3s;
    border: 1px solid #fff;
  }
`;

export default class PressmarkSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
    };

    this.onSearchValueChange = this.onSearchValueChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

  }
  onSearchValueChange = (e) => {
    let searchValue = e.target.value;
    this.setState(() => ({ searchValue }));
  };
  
  
  
  onSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit(this.state.searchValue);
  };

  render() {
    return (
      <form className="pt-5" onSubmit={this.onSubmit}>
        <input
          required
          pattern=".*\S+.*"
          type="text"
          placeholder="шина"
          autoFocus
          minLength={3}
          className="form-control"
          value={this.state.searchValue}
          onChange={this.onSearchValueChange}
        />
        <div>
          <button
            css={button}
          >
            Найти
          </button>
        </div>
      </form>
    );
  }
}